import client from './client';

export const list = () => client.get('/children/').then(r => r.data);

export const register = (formData) =>
  client.post('/children/', formData).then(r => r.data);

export const update = (id, data) =>
  client.patch(`/children/${id}`, data).then(r => r.data);

export const remove = (id) => client.delete(`/children/${id}`);
